import React from 'react';
import styles from './SectionHeader.module.css';
import { ComingSoon } from './ComingSoon';

interface SectionHeaderProps {
  title?: string;
  subtitle?: string;
  caption?: string;
  variant?: 'dark' | 'light';
  titleId?: string;
  className?: string;
  marginBottom?: string;
  showComingSoon?: boolean;
  maxWidth?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  caption,
  variant = 'dark',
  titleId,
  className,
  marginBottom,
  showComingSoon = false,
  maxWidth,
}) => {
  const mbMobile = marginBottom || '13.8rem';
  const mbLg =
    marginBottom === '40px'
      ? '120px'
      : marginBottom === '16rem'
      ? '16rem'
      : marginBottom || '13.8rem';

  return (
    <div
      className={
        className
          ? `${styles.headerContainer} ${className}`
          : styles.headerContainer
      }
      data-coming-soon={showComingSoon ? 'true' : 'false'}
      style={
        { ['--sh-mb']: mbMobile, ['--sh-mb-lg']: mbLg } as React.CSSProperties
      }
    >
      {showComingSoon && <ComingSoon variant={variant} />}
      {title ? (
        <h2 className={styles.mainHeading} data-variant={variant} id={titleId}>
          {title}
        </h2>
      ) : null}
      {caption && (
        <p className={styles.captionText} data-variant={variant}>
          {caption}
        </p>
      )}
      {subtitle ? (
        <p
          className={styles.descriptionText}
          data-variant={variant}
          style={
            maxWidth
              ? ({ ['--dt-max-width']: maxWidth } as React.CSSProperties)
              : undefined
          }
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
};
